// extracted by mini-css-extract-plugin
module.exports = {"ABRS":"RiverBasePC_ABRS__9eYdW"};